import { SweetAlert } from "@commonComponents";
import type { NavigateFunction } from "react-router";

export const navigateToParentRoute = (navigate: NavigateFunction) => {
  const url = new URL(window.location.href);
  const segments = url.pathname.split("/").filter(Boolean);

  let newPath = "/";
  if (segments[segments.length - 1] === "add") {
    newPath += segments.slice(0, -1).join("/");
  } else {
    // We are assuming it is view/edit and a uuid
    newPath += segments.slice(0, -2).join("/");
  }

  return navigate(newPath + url.search + url.hash);
};

export const promptNavigate = (
  navigate: NavigateFunction,
  url?: string,
  block: boolean = false,
  message: string = "You have unsaved changes that will be lost if you leave this page",
) => {
  if (block) {
    SweetAlert({
      title: "Are you sure?",
      text: message,
      success: () => (url ? navigate(url) : navigateToParentRoute(navigate)),
      showCancelButton: true,
      isWarning: true,
    });
  } else {
    url ? navigate(url) : navigateToParentRoute(navigate);
  }
};
